import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_long-arrow-left",
  "use": "icon_long-arrow-left-usage",
  "viewBox": "0 0 20 10",
  "content": "<symbol viewBox=\"0 0 20 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_long-arrow-left\"><path d=\"M5.9848 6.78569H19.4643C19.7601 6.78569 20 6.54582 20 6.24997V3.74998C20 3.45413 19.7601 3.21426 19.4643 3.21426H5.9848V1.15806C5.9848 0.20351 4.83074 -0.274525 4.15574 0.400429L0.313828 4.24234C-0.104609 4.66078 -0.104609 5.33917 0.313828 5.75756L4.15574 9.59947C4.8307 10.2744 5.9848 9.79639 5.9848 8.84184V6.78569Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol